import { Node as ProseMirrorNode, type DOMOutputSpec } from '@tiptap/pm/model';
import type { NodeView } from '@tiptap/pm/view';
import { createColGroup } from './utils/createColGroup';
import type { NodeViewRendererProps } from '@tiptap/core';
import { isEqual } from 'lodash-es';

export class WordTableView implements NodeView {
    node: ProseMirrorNode;

    getPos: () => number;

    dom: HTMLDivElement;

    colgroup: DOMOutputSpec;

    colgroupDOM: HTMLTableColElement;

    contentDOM: HTMLTableSectionElement;

    constructor({ editor, node, getPos, HTMLAttributes, decorations, extension }: NodeViewRendererProps) {
        this.node = node;
        this.getPos = getPos;
        this.dom = document.createElement('table');
        Object.entries(HTMLAttributes).forEach(([key, value]) => {
            this.dom.setAttribute(key, value);
        });
        const { colgroup, colgroupElement } = createColGroup(node, this.getPos());
        this.colgroup = colgroup;
        this.colgroupDOM = this.dom.appendChild(colgroupElement);
        this.contentDOM = this.dom.appendChild(document.createElement('tbody'));
    }

    update(node: ProseMirrorNode) {
        if (!node.sameMarkup(this.node)) return false;

        this.node = node;
        const { colgroup, colgroupElement } = createColGroup(node, this.getPos());
        if (!isEqual(this.colgroup, colgroup)) {
            this.colgroup = colgroup;
            this.colgroupDOM.innerHTML = colgroupElement.innerHTML;
        }

        return true;
    }

    ignoreMutation(mutation) {
        return mutation.type === 'attributes' && (mutation.target === this.dom || this.colgroupDOM.contains(mutation.target));
    }
}
